const assetConfig = JSON.parse(document.getElementById('ran-assets').textContent);
function initCosmos(el) {
    const kind = 'planet', motion = true, color = '#b399d3', active = 0;
    let disposed = false;
    let cleanup = () => { };
    let started = false;
    const observer = new IntersectionObserver(async (entries) => {
        if (!entries[0].isIntersecting || started)
            return;
        started = true;
        try {
            const T = await import(assetConfig.three);
            if (disposed)
                return;
            const mobile = matchMedia('(max-width:760px)').matches;
            const reduced = matchMedia('(prefers-reduced-motion: reduce)');
            const renderer = new T.WebGLRenderer({ alpha: true, antialias: true, powerPreference: 'low-power' });
            renderer.setPixelRatio(Math.min(devicePixelRatio, mobile ? 1.25 : 1.5));
            el.appendChild(renderer.domElement);
            renderer.domElement.addEventListener('webglcontextlost', () => { disposed = true; cleanup(); el.classList.remove('is-ready'); }, { once: true });
            renderer.outputColorSpace = T.SRGBColorSpace;
            renderer.toneMapping = T.ACESFilmicToneMapping;
            renderer.toneMappingExposure = 1.05;
            const textures = [];
            const loader = new T.TextureLoader();
            const texture = async (name) => { const map = await loader.loadAsync(assetConfig.textures[name]); map.colorSpace = T.SRGBColorSpace; map.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy()); textures.push(map); return map; };
            const scene = new T.Scene();
            const camera = new T.PerspectiveCamera(38, 1, .1, 100);
            camera.position.z = kind === 'planet' ? 8 : 6;
            scene.add(new T.AmbientLight(kind === 'planet' ? 0x9cabb8 : 0xffffff, kind === 'planet' ? .42 : .8));
            const light = new T.DirectionalLight(kind === 'planet' ? 0xe3efff : 0xfff4e7, 2.6);
            light.position.set(-5, 1.2, 1.4);
            scene.add(light);
            const rim = new T.DirectionalLight(kind === 'planet' ? 0x99eaff : 0x8baeff, kind === 'planet' ? .12 : .65);
            rim.position.set(.3, 3.5, .6);
            scene.add(rim);
            const earthFill=new T.DirectionalLight(0x668ccf,.45);earthFill.position.set(3,0,4);scene.add(earthFill);
            const orbiters = [];
            const group = new T.Group();
            scene.add(group);
            const segments = mobile ? 24 : 48;
            if (kind === 'planet') {
                const [map,nightMap,cloudMap] = await Promise.all([texture('earth'),texture('earthNight'),texture('earthClouds')]);
                if(disposed){map.dispose();renderer.dispose();return;}
                const earth = new T.Mesh(new T.SphereGeometry(1.65,mobile?48:80,mobile?32:56),new T.MeshStandardMaterial({map,color:0xb5d9f5,emissive:0xffd19a,emissiveMap:nightMap,emissiveIntensity:2.2,roughness:.8,metalness:0}));
                // City lights emerge across the unlit hemisphere as the surface rotates.
                earth.material.onBeforeCompile=shader=>{
                    shader.vertexShader='varying float earthSunlight;\n'+shader.vertexShader;
                    shader.vertexShader=shader.vertexShader.replace('#include <begin_vertex>', '#include <begin_vertex>\nearthSunlight=dot(normalize(mat3(modelMatrix)*normal),normalize(vec3(-5.,1.2,1.4)));');
                    shader.fragmentShader='varying float earthSunlight;\n'+shader.fragmentShader;
                    shader.fragmentShader=shader.fragmentShader.replace('#include <emissivemap_fragment>', '#include <emissivemap_fragment>\ntotalEmissiveRadiance *= 1.0-smoothstep(-0.18,0.24,earthSunlight);');
                };
                group.add(earth); group.userData.moon=group;
                const clouds=new T.Mesh(new T.SphereGeometry(1.659,mobile?40:64,mobile?28:40),new T.MeshStandardMaterial({map:cloudMap,transparent:true,opacity:.48,depthWrite:false,roughness:1}));
                group.add(clouds);group.userData.clouds=clouds;
                const glow=new T.Mesh(new T.SphereGeometry(1.672,mobile?32:48,mobile?24:36),new T.ShaderMaterial({transparent:true,depthWrite:false,blending:T.AdditiveBlending,side:T.FrontSide,vertexShader:`varying vec3 n;varying vec3 v;void main(){vec4 p=modelViewMatrix*vec4(position,1.);n=normalize(normalMatrix*normal);v=normalize(-p.xyz);gl_Position=projectionMatrix*p;}`,fragmentShader:`varying vec3 n;varying vec3 v;void main(){float a=pow(1.-abs(dot(normalize(n),normalize(v))),3.);gl_FragColor=vec4(.06,.48,1.,a*.34);}`}));scene.add(glow);
                group.rotation.z=.1; group.rotation.y=-1.22;
            }
            else if (kind === 'gem') {
                const vertices = [];
                const sides = 6;
                const upper = new T.Vector3(0, 1.35, 0), lower = new T.Vector3(0, -1.1, 0);
                for (let i = 0; i < sides; i++) {
                    const a = i / sides * Math.PI * 2, b = (i + 1) / sides * Math.PI * 2;
                    const p = new T.Vector3(Math.cos(a) * .72, .45, Math.sin(a) * .72), q = new T.Vector3(Math.cos(b) * .72, .45, Math.sin(b) * .72), r = new T.Vector3(Math.cos(a) * .65, -.55, Math.sin(a) * .65), s = new T.Vector3(Math.cos(b) * .65, -.55, Math.sin(b) * .65);
                    for (const v of [upper, p, q, p, r, q, q, r, s, r, lower, s])
                        vertices.push(v.x, v.y, v.z);
                }
                const geo = new T.BufferGeometry();
                geo.setAttribute('position', new T.Float32BufferAttribute(vertices, 3));
                geo.computeVertexNormals();
                const mesh = new T.Mesh(geo, new T.MeshPhysicalMaterial({ color, metalness: .2, roughness: .18, clearcoat: 1, flatShading: true, transparent: true, opacity: .91, side: T.DoubleSide }));
                group.add(mesh);
                group.rotation.set(.18, .3, .22);
                const edges = new T.LineSegments(new T.EdgesGeometry(geo), new T.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: .15 }));
                group.add(edges);
            }
            else {
                const points = [];
                for (let i = 0; i < 7; i++) {
                    const x = (i - 3) * .44, y = Math.sin(i * 1.7 + active * .7) * .7, z = Math.cos(i + active) * .5;
                    const point = new T.Vector3(x, y, z);
                    points.push(point);
                    const star = new T.Mesh(new T.SphereGeometry(i % 3 === 0 ? .06 : .036, 8, 8), new T.MeshBasicMaterial({ color: 0xe4cffd }));
                    star.position.copy(point);
                    group.add(star);
                }
                group.add(new T.Line(new T.BufferGeometry().setFromPoints(points), new T.LineBasicMaterial({ color: 0x9a78bf, transparent: true, opacity: .6 })));
            }
            if (kind !== 'gem') {
                const count = mobile ? 95 : 240;
                const positions = new Float32Array(count * 3);
                for (let i = 0; i < count; i++) {
                    positions[i * 3] = Math.sin(i * 123.4) * 9;
                    positions[i * 3 + 1] = Math.cos(i * 78.3) * 6;
                    positions[i * 3 + 2] = -2 - Math.abs(Math.sin(i * 34.4)) * 8;
                }
                const geo = new T.BufferGeometry();
                geo.setAttribute('position', new T.BufferAttribute(positions, 3));
                scene.add(new T.Points(geo, new T.PointsMaterial({ size: mobile ? .025 : .018, color: 0xddc6f4, transparent: true, opacity: .7 })));
            }
            let visible = true, id = 0, last = 0, orbitTime = 0;
            let pointerX = 0, pointerY = 0;
            let scrollDepth = 0;
            const canAnimate = () => motion && !reduced.matches && visible && !document.hidden && document.documentElement.dataset.motion !== 'off';
            const draw = (now = 0) => { id = 0; if (disposed)
                return; if (now - last > 1000 / (mobile ? 24 : 30)) {
                if (canAnimate()) {
                    orbitTime += Math.min(now - last, 50);
                    if (kind === 'planet') {
                        group.userData.moon.rotation.y += Math.min(now-last,80)*.00006;
                    if(group.userData.clouds) group.userData.clouds.rotation.y += Math.min(now-last,80)*.000009;
                    }
                    if (kind !== 'planet')
                        group.rotation.y += kind === 'gem' ? .006 : .0016;
                    orbiters.forEach(o => { o.mesh.children[0].rotation.y += .004; const angle = o.phase + orbitTime * o.speed; o.mesh.position.set(Math.cos(angle) * o.radius, Math.sin(angle) * o.radius * .85, -.15); });
                    if (kind === 'constellation')
                        group.rotation.z = Math.sin(now * .00016) * .08;
                    camera.position.x += (pointerX * .16 - camera.position.x) * .025;
                    camera.position.y += ((pointerY * .12 + scrollDepth * (mobile ? .08 : .3)) - camera.position.y) * .025;
                    if (kind === 'gem')
                        group.rotation.x = .18 + scrollDepth * .25;
                    camera.lookAt(0, 0, 0);
                }
                renderer.render(scene, camera);
                last = now;
            } if (canAnimate())
                id = requestAnimationFrame(draw); };
            const resume = () => { if (id)
                cancelAnimationFrame(id); id = 0; renderer.render(scene, camera); if (canAnimate())
                id = requestAnimationFrame(draw); };
            const resize = () => { const w = el.clientWidth, h = el.clientHeight; if (!w || !h)
                return; renderer.setSize(w, h, false); camera.aspect = w / h; if (kind === 'planet')
                camera.position.z = Math.max(6.7, 2.15 / (Math.tan(19 * Math.PI / 180) * camera.aspect)); camera.updateProjectionMatrix(); resume(); el.classList.add('is-ready'); };
            const ro = new ResizeObserver(resize);
            ro.observe(el);
            const io = new IntersectionObserver(e => { visible = e[0].isIntersecting; resume(); }, { threshold: .01 });
            io.observe(el);
            const pointer = (e) => { if (mobile)
                return; const rect = el.getBoundingClientRect(); pointerX = (e.clientX - rect.left) / rect.width - .5; pointerY = -((e.clientY - rect.top) / rect.height - .5); };
            const scroll = () => { if (visible) {
                const rect = el.getBoundingClientRect();
                scrollDepth = Math.max(-1, Math.min(1, (innerHeight * .5 - (rect.top + rect.height * .5)) / innerHeight));
            } };
            window.addEventListener('scroll', scroll, { passive: true });
            scroll();
            const motionObserver = new MutationObserver(resume);
            motionObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-motion'] });
            const parent = el.parentElement;
            parent?.addEventListener('pointermove', pointer);
            document.addEventListener('visibilitychange', resume);
            reduced.addEventListener('change', resume);
            resize();
            cleanup = () => { window.removeEventListener('scroll', scroll); motionObserver.disconnect(); cancelAnimationFrame(id); ro.disconnect(); io.disconnect(); parent?.removeEventListener('pointermove', pointer); document.removeEventListener('visibilitychange', resume); reduced.removeEventListener('change', resume); scene.traverse(o => { if (o instanceof T.Mesh || o instanceof T.Line || o instanceof T.Points) {
                o.geometry.dispose();
                const materials = Array.isArray(o.material) ? o.material : [o.material];
                materials.forEach(m => m.dispose());
            } }); textures.forEach(t => t.dispose()); renderer.dispose(); renderer.domElement.remove(); };
        }
        catch {
            if (!disposed)
                el.classList.remove('is-ready');
        }
    }, { rootMargin: '100px' });
    observer.observe(el);
    return () => { disposed = true; observer.disconnect(); cleanup(); };
}
function initShootingStars() {
    const canvas = document.querySelector('canvas.shooting-stars');
    if (!canvas)
        return;
    const context = canvas.getContext('2d');
    if (!context)
        return;
    const ctx = context;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0, width = 0, height = 0, next = 0, last = 0;
    let meteors = [];
    const enabled = () => !reduced.matches && !document.hidden && document.documentElement.dataset.motion !== 'off';
    const resize = () => { width = innerWidth; height = innerHeight; const dpr = Math.min(devicePixelRatio, 1.5); canvas.width = width * dpr; canvas.height = height * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    const draw = (now) => {
        if (!enabled()) {
            frame = 0;
            return;
        }
        if (now - last > 30) {
            last = now;
            ctx.clearRect(0, 0, width, height);
            if (now >= next) {
                const direction = Math.random() > .5 ? 1 : -1;
                meteors.push({ x: width * (direction === 1 ? .1 + Math.random() * .65 : .35 + Math.random() * .55), y: Math.random() * height * .8, dx: direction * (180 + Math.random() * 160), dy: 100 + Math.random() * 130, start: now, duration: 1500 + Math.random() * 650, length: width < 760 ? 100 : 170 });
                next = now + 1700 + Math.random() * 2200;
            }
            meteors = meteors.filter(m => now - m.start < m.duration);
            for (const m of meteors) {
                const t = (now - m.start) / m.duration, x = m.x + m.dx * t, y = m.y + m.dy * t, angle = Math.atan2(m.dy, m.dx), tx = x - Math.cos(angle) * m.length, ty = y - Math.sin(angle) * m.length;
                ctx.globalAlpha = Math.sin(Math.PI * t) * .95;
                const gradient = ctx.createLinearGradient(x, y, tx, ty);
                gradient.addColorStop(0, '#ffffff');
                gradient.addColorStop(.18, '#d2ddff');
                gradient.addColorStop(1, '#c5b4ff00');
                ctx.strokeStyle = gradient;
                ctx.lineWidth = 2;
                ctx.shadowColor = '#b5caff';
                ctx.shadowBlur = 8;
                ctx.beginPath();
                ctx.moveTo(tx, ty);
                ctx.lineTo(x, y);
                ctx.stroke();
                ctx.beginPath();
                ctx.arc(x, y, 1.7, 0, Math.PI * 2);
                ctx.fillStyle = '#ffffff';
                ctx.fill();
            }
            ctx.globalAlpha = 1;
            ctx.shadowBlur = 0;
        }
        frame = requestAnimationFrame(draw);
    };
    const resume = () => { cancelAnimationFrame(frame); frame = 0; meteors = []; ctx.clearRect(0, 0, width, height); next = performance.now() + 350; if (enabled())
        frame = requestAnimationFrame(draw); };
    resize();
    resume();
    const observer = new MutationObserver(resume);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-motion'] });
    window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', resume);
    reduced.addEventListener('change', resume);
    return () => { cancelAnimationFrame(frame); observer.disconnect(); window.removeEventListener('resize', resize); document.removeEventListener('visibilitychange', resume); reduced.removeEventListener('change', resume); };
}
const scenes = new Map();
function mount(scope = document) { scope.querySelectorAll('[data-cosmos]').forEach(el => { if (!scenes.has(el))
    scenes.set(el, initCosmos(el)); }); }
function syncMotion() { const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches; const off = document.documentElement.dataset.motion === 'off'; document.querySelectorAll('[data-motion-toggle]').forEach(button => { button.textContent = reduced ? 'Reduced motion' : off ? 'Enable motion' : 'Pause motion'; button.setAttribute('aria-pressed', String(off || reduced)); button.disabled = reduced; }); }
try {
    const saved = localStorage.getItem('ran-motion');
    if (saved === 'off' || saved === 'on')
        document.documentElement.dataset.motion = saved;
}
catch { }
document.addEventListener('click', event => { const button = event.target.closest('[data-motion-toggle]'); if (button) {
    document.documentElement.dataset.motion = document.documentElement.dataset.motion === 'off' ? 'on' : 'off';
    try {
        localStorage.setItem('ran-motion', document.documentElement.dataset.motion);
    }
    catch { }
    syncMotion();
} const sign = event.target.closest('[data-sign]'); if (sign) {
    const panel = sign.closest('[data-zodiac]');
    panel.querySelectorAll('[data-sign]').forEach(b => { b.classList.toggle('active', b === sign); b.setAttribute('aria-pressed', String(b === sign)); });
    panel.querySelectorAll('[data-reading]').forEach(p => p.hidden = p.dataset.reading !== sign.dataset.sign);
} });
matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', syncMotion);
const visibility = () => document.documentElement.dataset.skyHidden = document.hidden ? 'true' : 'false';
document.addEventListener('visibilitychange', visibility);
visibility();
mount();
initShootingStars();
syncMotion();
document.addEventListener('shopify:section:load', event => { mount(event.target); syncMotion(); });
document.addEventListener('shopify:section:unload', event => { for (const [el, dispose] of scenes) {
    if (event.target.contains(el)) {
        dispose?.();
        scenes.delete(el);
    }
} });
document.addEventListener('shopify:block:select', event => { const panel = event.target.closest('[data-zodiac]'); if (panel) {
    const id = event.target.dataset.reading;
    const button = Array.from(panel.querySelectorAll('[data-sign]')).find(b => b.dataset.sign === id);
    button?.click();
} });
document.addEventListener('change',event=>{if(event.target.matches('[data-variant-select]')){const area=event.target.closest('.product-layout');const price=area?.querySelector('[data-variant-price]');if(price)price.textContent=event.target.selectedOptions[0].dataset.price;const url=new URL(location.href);url.searchParams.set('variant',event.target.value);history.replaceState({},'',url);}});

// Photo banners: scoped timers and cleanup for Shopify's section editor.
const photoBanners = new Map();
function mountPhotoBanners(root=document){
 root.querySelectorAll('[data-photo-banner]').forEach(section=>{
  if(photoBanners.has(section))return;
  const track=section.querySelector('.client-photo-grid'),slides=[...track.querySelectorAll('figure')];
  if(!slides.length)return;
  const rail=document.createElement('div');rail.className='photo-banner-rail';slides.forEach(slide=>rail.append(slide));track.append(rail);
  const controls=section.querySelector('.photo-controls'),pause=section.querySelector('[data-photo-pause]'),count=section.querySelector('[data-photo-count]');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)'),abort=new AbortController(),options={signal:abort.signal};
  let flow=null,flowWidth=0;
  let index=0,userPaused=false,visible=false,startX=null,timer=null,resetTimer=null;
  track.classList.add('photo-slider','moving-photo-banner');controls.hidden=slides.length<2;
  slides.forEach(slide=>{const clone=slide.cloneNode(true);clone.removeAttribute('data-shopify-editor-block');clone.setAttribute('aria-hidden','true');clone.inert=true;rail.append(clone);});
  const slideOffset=i=>slides.slice(0,i).reduce((width,slide)=>width+slide.getBoundingClientRect().width,0);
  const render=()=>{const offset=slideOffset(index);if(flow&&flowWidth){flow.currentTime=offset/flowWidth*flow.effect.getTiming().duration;}else{rail.style.transition='none';rail.style.transform=`translate3d(${-offset}px,0,0)`;}count.textContent=`${index+1} / ${slides.length}`;};
  const allowed=()=>!userPaused&&!reduced.matches&&!document.hidden&&visible&&startX===null&&document.documentElement.dataset.motion!=='off';
  const schedule=()=>{clearTimeout(timer);
    {
      const width=slideOffset(slides.length);
      if(!width)return;
      if(!flow||Math.abs(width-flowWidth)>1){const progress=flow?((flow.currentTime||0)/flow.effect.getTiming().duration)%1:index/slides.length;if(flow)flow.cancel();flowWidth=width;rail.style.transition='none';rail.style.transform='none';flow=rail.animate([{transform:'translate3d(0,0,0)'},{transform:`translate3d(${-width}px,0,0)`}],{duration:width/26*1000,iterations:Infinity,easing:'linear'});flow.currentTime=progress*flow.effect.getTiming().duration;}
      if(allowed()&&slides.length>1)flow.play();else flow.pause();return;
    }
  };
  const move=delta=>{if(flow){const offset=((flow.currentTime||0)/flow.effect.getTiming().duration)%1*flowWidth;index=slides.findIndex((slide,i)=>slideOffset(i+1)>offset);if(index<0)index=0;}index=(index+delta+slides.length)%slides.length;render();schedule();};
  section.querySelector('[data-photo-prev]').addEventListener('click',()=>move(-1),options);
  section.querySelector('[data-photo-next]').addEventListener('click',()=>move(1),options);
  pause.addEventListener('click',()=>{userPaused=!userPaused;pause.textContent=userPaused?'Play slideshow':'Pause slideshow';pause.setAttribute('aria-pressed',String(userPaused));schedule();},options);
  track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},options);
  track.addEventListener('pointerdown',e=>{startX=e.clientX;schedule();track.setPointerCapture(e.pointerId);},options);
  track.addEventListener('pointerup',e=>{if(startX!==null&&Math.abs(e.clientX-startX)>45)move(e.clientX<startX?1:-1);startX=null;schedule();},options);
  track.addEventListener('pointercancel',()=>{startX=null;schedule();},options);
  track.addEventListener('dragstart',e=>e.preventDefault(),options);
  document.addEventListener('visibilitychange',schedule,options);reduced.addEventListener('change',schedule,options);
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.15});observer.observe(track);
  const resize=new ResizeObserver(schedule);resize.observe(track);slides.forEach(slide=>resize.observe(slide));
  const motionObserver=new MutationObserver(schedule);motionObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-motion']});
  section.addEventListener('shopify:block:select',e=>{const i=slides.findIndex(slide=>slide===e.target||slide.contains(e.target));if(i>=0){index=i;userPaused=true;pause.textContent='Play slideshow';pause.setAttribute('aria-pressed','true');render();schedule();}},options);
  render(false);photoBanners.set(section,()=>{clearTimeout(timer);clearTimeout(resetTimer);if(flow)flow.cancel();abort.abort();observer.disconnect();resize.disconnect();motionObserver.disconnect();});
 });
}
mountPhotoBanners();
document.addEventListener('shopify:section:load',e=>mountPhotoBanners(e.target));
document.addEventListener('shopify:section:unload',e=>{for(const [section,dispose] of photoBanners){if(e.target.contains(section)){dispose();photoBanners.delete(section);}}});

document.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-step]');if(!button)return;const gallery=document.getElementById(button.getAttribute('aria-controls'));if(gallery)gallery.scrollBy({left:Number(button.dataset.galleryStep)*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

document.addEventListener('click',e=>{const b=e.target.closest('[data-chakra-pause]');if(!b)return;const section=b.closest('.chakra-ribbon');const paused=section.dataset.paused!=='true';section.dataset.paused=String(paused);b.setAttribute('aria-pressed',String(paused));b.textContent=paused?'Play stones':'Pause stones';});
